import React from 'react';
import { Bus, TrendingUp, Award } from 'lucide-react';

export const routesData = [
  {
    id: 'cruiser',
    title: 'The Cruiser',
    trains: 'P058 & P158',
    route: 'Danville ↔ Norfolk',
    description: 'Round trip passenger service connecting Danville, VA to Norfolk, VA with convenient stops across southern Virginia.',
    stations: [
      { name: 'KingsPort', code: 'KGP', type: 'AG&W' },
      { name: 'Danville', code: 'DAN', type: 'Amtrak' },
      { name: 'South Boston', code: 'SBN', type: 'AG&W' },
      { name: 'Clarkesville', code: 'CLV', type: 'AG&W' },
      { name: 'South Hill', code: 'SOH', type: 'AG&W' },
      { name: 'Lawrenceville', code: 'LRV', type: 'AG&W' },
      { name: 'Emporia', code: 'EMP', type: 'AG&W' },
      { name: 'Franklin', code: 'FLN', type: 'AG&W' },
      { name: 'Suffolk', code: 'SFK', type: 'AG&W' },
      { name: 'Portsmouth', code: 'PTM', type: 'AG&W' },
      { name: 'Norfolk', code: 'NFK', type: 'Amtrak' }
    ]
  },
  {
    id: 'libertarian',
    title: 'The Libertarian',
    trains: 'P301 & P295',
    route: 'Danville ↔ NY Penn',
    description: 'Long-distance passenger service connecting Virginia to New York with extensive stops along the East Coast corridor.',
    stations: [
      { name: 'KingsPort', code: 'KGP', type: 'AG&W' },
      { name: 'Danville', code: 'DAN', type: 'Amtrak' },
      { name: 'South Boston', code: 'SBN', type: 'AG&W' },
      { name: 'Clarkesville', code: 'CLV', type: 'AG&W' },
      { name: 'South Hill', code: 'SOH', type: 'AG&W' },
      { name: 'Lawrenceville', code: 'LRV', type: 'AG&W' },
      { name: 'Emporia', code: 'EMP', type: 'AG&W' },
      { name: 'Petersburg', code: 'PTB', type: 'Amtrak' },
      { name: 'Rich-Staple Mill Rd', code: 'RVR', type: 'Amtrak' },
      { name: 'Ashland', code: 'ASH', type: 'Amtrak' },
      { name: 'Fredericksburg', code: 'FBG', type: 'Amtrak' },
      { name: 'Quantico', code: 'QAN', type: 'Amtrak' },
      { name: 'Alexandria', code: 'ALX', type: 'Amtrak' },
      { name: 'Washington DC Union', code: 'WAS', type: 'Union Trans' },
      { name: 'Baltimore', code: 'BAL', type: 'Uni/Amtrak' },
      { name: 'Wilmington', code: 'WIL', type: 'Uni/Amtrak' },
      { name: 'Philadelphia', code: 'PHL', type: 'Uni/Amtrak' },
      { name: 'Trenton', code: 'TRE', type: 'Uni/Amtrak' },
      { name: 'Metropark', code: 'MET', type: 'Uni/Amtrak' },
      { name: 'Newark Liberty', code: 'EWK', type: 'Uni/Amtrak' },
      { name: 'Newark Penn St', code: 'NWK', type: 'Uni/Amtrak' },
      { name: 'New York Penn', code: 'NYP', type: 'Uni/Amtrak' }
    ]
  },
  {
    id: 'southsidean',
    title: 'The Southsidean',
    trains: 'P121 & P117',
    route: 'Danville ↔ Miami',
    description: 'Premier long-haul passenger service connecting Virginia to Florida with comfortable service through the Southeast.',
    stations: [
      { name: 'KingsPort', code: 'KGP', type: 'AG&W' },
      { name: 'Danville', code: 'DAN', type: 'Amtrak' },
      { name: 'South Boston', code: 'SBN', type: 'AG&W' },
      { name: 'Clarkesville', code: 'CLV', type: 'AG&W' },
      { name: 'South Hill', code: 'SOH', type: 'AG&W' },
      { name: 'Emporia', code: 'EMP', type: 'AG&W' },
      { name: 'Rocky Mt, NC', code: 'RMT', type: 'Amtrak' },
      { name: 'Fayetteville', code: 'FAY', type: 'Amtrak' },
      { name: 'Florence, SC', code: 'FLO', type: 'Amtrak' },
      { name: 'KingsTree', code: 'KTR', type: 'Amtrak' },
      { name: 'Charleston', code: 'CHS', type: 'Amtrak' },
      { name: 'Yemassee, SC', code: 'YEM', type: 'Amtrak' },
      { name: 'Savannah, GA', code: 'SAV', type: 'Amtrak' },
      { name: 'Jacksonville, FL', code: 'JAX', type: 'Amtrak' },
      { name: 'Palatka', code: 'PAK', type: 'Amtrak' },
      { name: 'WinterPark', code: 'WPK', type: 'Amtrak' },
      { name: 'Orlando', code: 'ORL', type: 'Amtrak' },
      { name: 'Kissimmee', code: 'KIS', type: 'Amtrak' },
      { name: 'Winter Haven', code: 'WTH', type: 'Amtrak' },
      { name: 'West Palm Beach', code: 'WPB', type: 'Amtrak' },
      { name: 'Delray Beach', code: 'DLB', type: 'Amtrak' },
      { name: 'Ft. Lauderdale', code: 'FTL', type: 'Amtrak' },
      { name: 'Miami, FL', code: 'MIA', type: 'Amtrak' }
    ]
  }
];

export const otherProjectsData = [
  {
    title: 'Thru-Way Connections',
    category: 'Bus Service',
    icon: <Bus size={32} />,
    description: 'Complimentary bus service connecting passengers to stations. Free transportation to designated stations for ticketed passengers unable to reach the station, and backup service during train breakdowns.',
    stats: {
      service: 'Bus Routes',
      cost: 'Complimentary',
      coverage: 'All Routes'
    },
    status: 'Operational',
    image: null
  },
  {
    title: 'Freight Operations',
    category: 'Freight Service',
    icon: <TrendingUp size={32} />,
    description: 'Intermodal freight transport managing private cargo and short-line operations for major companies, ensuring efficient delivery across the network.',
    stats: {
      service: 'Intermodal',
      clients: 'Major Corps',
      reliability: 'High'
    },
    status: 'Operational',
    image: 'https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/otauecpy_yuj.webp'
  },
  {
    title: 'Future Amtrak Partnership',
    category: 'Partnership Initiative',
    icon: <Award size={32} />,
    description: 'Planned partnership to provide rail opportunities to Amtrak passengers, helping them avoid delayed routes by offering reliable alternative services.',
    stats: {
      partner: 'Amtrak',
      status: 'Planning',
      goal: 'Delay Prevention'
    },
    status: 'In Planning',
    image: 'https://customer-assets.emergentagent.com/job_western-rail-hub/artifacts/6fvp5c8h_amtrak_logo.jpg'
  }
];
